import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import '@mdi/font/css/materialdesignicons.css'
import 'vue-select/dist/vue-select.css'
import 'type-icons/dist/type-icons.css'
import 'flag-icons/css/flag-icons.min.css'
import vSelect from 'vue-select'
import VueI18n from 'vue-i18n'
import { defaultLocale, messages } from '@/i18n'
import moment from 'moment'
import filters from './plugins/filters'
import VueGtag from 'vue-gtag'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from 'vee-validate'
import es from 'vee-validate/dist/locale/es.json'
import * as rules from 'vee-validate/dist/rules'
import directives from './plugins/directives'

Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.config.performance = true
Vue.prototype.$log = console.log

// Install VeeValidate rules and localization
for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  })
}
localize('es', es)

// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('v-select', vSelect)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueI18n)
Vue.use(filters)
Vue.use(directives)
Vue.use(VueGtag, {
  enabled: process.env.VUE_APP_GTAG_ENABLED,
  config: {
    id: process.env.VUE_APP_GA,
    params: {
      user_id: store.state.user.username
    }
  }
})

const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-GB',
  silentFallbackWarn: true
})

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')

// Set user properties
app.$gtag.set({
  user_properties: { ...store.state.user, crm_id: store.state.user.username }
})

const DEFAULT_TITLE = 'CCP'
router.afterEach((to) => {
  // Save in GA4 the user navigation
  app.$gtag.pageview({
    page_title: to.name?.toString(),
    page_path: to.fullPath,
    page_location: window.location.toString()
  })

  Vue.nextTick(() => {
    document.title = i18n.t(to.meta.title).toString() || DEFAULT_TITLE
  })
})
